<template>
  <transition name="slide">
    <div class="flex items-center justify-between bg-yellow-500 text-white rounded-lg py-3 px-2 my-2 text"
         v-if="show">
      <span>{{ notification }}</span>
      <button class="bg-red-500 rounded-lg p-1 px-2" @click="setSeen">X</button>
    </div>
  </transition>
</template>

<script>
import {setNotificationAsRead} from "../../API/API";

export default {
  name: "Notification",
  props: ['notification'],
  data() {
    return {
      show: true
    }
  },
  methods: {
    setSeen() {
      this.show = false
      setNotificationAsRead(this.notification.SIGNAL_ID)
    }
  }
}
</script>

<style scoped>

</style>